import * as React from 'react';
import './social.scss';

const Social = ({ facebookurl, twitterurl }) => {
  return (
    <div className="social has-text-centered">
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${facebookurl}/`}
        target="_blank"
        rel="noreferrer"
      >
        <span className="share-icon">
          <svg
            id="facebook"
            viewBox="0 0 100 100"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M82.026,14H17.974C15.779,14,14,15.779,14,17.974v64.053C14,84.221,15.779,86,17.974,86h34.483V58.118h-9.383V47.252h9.383 v-8.014c0-9.3,5.68-14.363,13.976-14.363c3.974,0,7.389,0.295,8.385,0.428v9.719l-5.754,0.003c-4.512,0-5.385,2.144-5.385,5.29 v6.938h10.76l-1.401,10.866h-9.359V86h18.348C84.221,86,86,84.221,86,82.026V17.974C86,15.779,84.221,14,82.026,14z"></path>
          </svg>
        </span>
        <span className="share-word">Share</span>
      </a>
      <a
        href={`https://twitter.com/intent/tweet?url=${twitterurl}`}
        target="_blank"
        rel="noreferrer"
      >
        <span className="share-icon">
          <svg
            id="twitter"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            x="0px"
            y="0px"
            viewBox="0 0 35 35"
          >
            <style type="text/css"></style>
            <polygon
              className="st0"
              points="17.7,15.8 12.5,8.4 9.7,8.4 16.2,17.6 17,18.8 17,18.8 22.5,26.7 25.3,26.7 18.5,17 "
            />
            <path
              className="st0"
              d="M30.7,1.6H4.3c-1.5,0-2.7,1.2-2.7,2.7v26.4c0,1.5,1.2,2.7,2.7,2.7h26.4c1.5,0,2.7-1.2,2.7-2.7V4.3  C33.4,2.8,32.2,1.6,30.7,1.6L30.7,1.6z M21.6,28L16,19.8L9,28H7.2l8-9.3L7.2,7h6.1l5.3,7.7L25.3,7h1.8l-7.6,8.9l0,0L27.8,28H21.6  L21.6,28z"
            />
          </svg>
        </span>
        <span className="share-word">Post</span>
      </a>
    </div>
  );
};

export default Social;
